import styled from 'styled-components';
import { useGetUserList } from '../../../interface/common';
import theme from '../../../styles/theme';
import Button from '../../common/Button';
import { useState, useEffect } from 'react';
import CommonDataGrid from '../../common/CommonDataGrid';
import moment from 'moment';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import UserForm from './UserForm';
import FullModal from '../../common/modal/FullModal';
import MsgModal from '../../common/modal/MsgModal';

const MainWrap = styled.div`
    padding: 0.25rem 1.5rem; 
    h3 {
        font-size: ${theme.fontSize.base};
        font-weight: 600;
        margin: 0;
        color: ${theme.color.black};
    }
    div {
        color: ${theme.color.black};
        font-size: ${theme.fontSize.base};
    }
    transition: ${theme.windowSize.drawerTransition};
`;

const columns = [
    { field: 'uid', headerName: 'No', width: 60, headerAlign:'center', align:'right'},
    { field: 'user_no', headerName: 'ID', width: 90 },
    { field: 'user_nm', headerName: '이름', width: 80 },
    { field: 'user_tpnm', headerName: '사용자권한', width: 100 },
    { field: 'dept_cdnm', headerName: '부서', width: 100, align:'center'},
    { field: 'reg_dt', headerName: '등록일', width: 160, align:'right'},
    { field: 'mod_dt', headerName: '수정일', width: 160, align:'right'},
    { field: 'is_use', headerName: '사용여부', width:80, headerAlign:'center', align:'center'},
]

const Users = () => {

    const [is_use, setIs_use] = useState();
    const [list, setList] = useState([]);
    const [regOpen, setRegOpen] = useState(false);
    const [target, setTarget] = useState();

    const {data: userList, isLoading: userListLoading, refetch} = useGetUserList({is_use:is_use});

    useEffect(()=>{
        if(userList){
            setList(userList.map((item,index)=>(
                                    {
                                        ...item,
                                        id:index,
                                        reg_dt: item.reg_dt ? moment(item.reg_dt).format('YYYY/MM/DD HH:mm') : '',
                                        mod_dt: item.mod_dt ? moment(item.mod_dt).format('YYYY/MM/DD HH:mm') : '',
                                        is_use: item.is_use === 1 ? '사용' : '정지'
                                    }
                                )));
        }else{
            setList([])
        }
    },[userList])

    useEffect(()=>{
        refetch();
    },[is_use])

    return (
        <MainWrap>
            <h3>사용자 관리</h3>
            <div style={{height:'0.8rem'}} />
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <FormControl style={{width:'10rem'}} size='small'>
                    <InputLabel id='isUse-label'>사용여부</InputLabel>
                    <Select label="사용여부" labelId='isUse-label' size='small'>
                        <MenuItem value={''} onClick={()=>setIs_use(undefined)} >전체</MenuItem>
                        <MenuItem 
                            value={1} 
                            onClick={()=>setIs_use(1)}
                        >
                            사용
                        </MenuItem>
                        <MenuItem 
                            value={0} 
                            onClick={()=>setIs_use(0)}
                        >
                            정지
                        </MenuItem>
                    </Select>
                </FormControl>
                <Button onClick={()=>{setTarget();setRegOpen(true);}} style={{width:'150px'}}>사용자추가</Button>
            </div>
            <div style={{height:'0.8rem'}} />
            <div style={{height:'80vh'}}>
            <CommonDataGrid
                isLoading={userListLoading}
                list={list}
                columns={columns}
                onRowClick={(e)=>{setTarget(e.row);setRegOpen(true);}}
                />
            </div>
            <MsgModal open={regOpen}>
                <DetailWrap target={target} onClose={setRegOpen} />
            </MsgModal>
        </MainWrap>
    )

}

const DetailWrapStyle = styled.div`
    width: 100%;
    height: 100%;
    // border: 1px solid red;
`;

const DetailWrap = ({target, onClose}) => {
    return (
        <DetailWrapStyle>
            <UserForm target={target} onClose={onClose}/>
        </DetailWrapStyle>
    )
}

export default Users;